'use strict';

+function ($) {

  // create, show, and return a simple static modal
  basecoat.modal = function (content, type, size) {
    type = type || 'alert';
    size = size || 'md';
    var $modal = $(''
    + '<div class="modal ' + type + '-modal fade" tabindex="-1" role="dialog">'
      + '<div class="modal-dialog modal-' + size + '" role="document">'
        + '<div class="modal-content">'
          + content
          + '</div>'
        + '</div>'
      + '</div>'
    );

    $modal.modal({
      keyboard: false,
      backdrop: 'static'
    })
    .on('hidden.bs.modal', function () {
      $(this).data('bs.modal', null).remove();
    });

    return $modal;
  };

  // create, show, and return a dialog modal with buttons
  basecoat.dialogModal = function (heading, message, buttons) {
    var content = '';

    if (heading) {
      content += ''
      + '<div class="modal-header">'
        + '<h5 class="modal-title">'
          + heading
        + '</h5>'
      + '</div>';
    }

    if (message) {
      content += ''
      + '<div class="modal-body">'
        + '<p>'
          + message
        + '</p>'
      + '</div>';
    }

    if (buttons) {
      var $footer = $('<div class="modal-footer"><div class="btn-link-toolbar"/></div>');
      $.each(buttons, function (key, value) {
        $footer.find('.btn-link-toolbar').append(
          '<button type="button" class="btn btn-link" data-dismiss="modal" onClick="$(this).closest(\'.modal\').trigger(\'' + key + '\')" data-modal-btn="' + key + '">'
            + value +
          '</button>'
        );
      });
      content += $footer.prop('outerHTML');
    }

    return basecoat.modal(content);
  };

  basecoat.alert = function (heading, message, accept) {
    return basecoat.dialogModal(heading, message, {
      accept: accept || 'OK'
    });
  };

  basecoat.confirm = function (heading, message, accept, reject) {
    return basecoat.dialogModal(heading, message, {
      reject: reject || 'Cancel',
      accept: accept || 'OK'
    });
  };

  $(document)
  // add a temp hash when opening full-modal
  .on('shown.bs.modal', '.modal.full-modal', function () {
    window.history.pushState('forward', null, '#openModal');
  })
  // remove the temp hash after closing full-modal
  .on('hidden.bs.modal', '.modal.full-modal', function () {
    if (location.hash === '#openModal') {
      window.history.back();
    }
  });

  $(window)
  // close the full-modal when user presses "back" button
  .on('popstate.bc.modal', function (e) {
    if (e.state !== null) {
      $('.modal.full-modal.in').modal('hide');
    }
  });

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/modal.js
// module id = 9
// module chunks = 0